<template>
    <div>
        <h5>Please provide your payment details:</h5>
        <stripe-element-payment
            v-if="showCardPaymentForm"
            ref="paymentRef"
            :pk="stripeKey"
            redirect="always"
            :elements-options="elementsOptions"
            :confirm-params="confirmParams"
            :stripe-account="stripeConnectId"
            @error="showError"
        />
    </div>
</template>

<script>
import { StripeElementPayment } from '@vue-stripe/vue-stripe';

import PaymentBus from './payment-bus';

export default {
    data() {
        return {
            showCardPaymentForm: false,
            complete: false,
            stripeKey: window.stripePubKey,
            eventBooking: this.$store.getters.getEventBooking,
            stripeConnectId: null,
            confirmParams: {
                return_url: window.location.href.replace(
                    '#/payment',
                    '#/summary'
                ),
            },
            elementsOptions: {
                hidePostalCode: true,
            },
        };
    },

    created() {
        // Payment Intent call, created from payment vue, after costs calculated
        PaymentBus.$on('payCard', () => this.pay());

        PaymentBus.$on('completeIntent', (clientSecret, connectId) => {
            this.elementsOptions.clientSecret = clientSecret;
            this.stripeConnectId = connectId;
            this.showCardPaymentForm = true;
            this.$forceUpdate();
        });
    },

    mounted() {},

    components: {
        StripeElementPayment,
    },

    methods: {
        showError(error) {
            this.$notify.warning({
                title: 'Payment Problem',
                message: 'Please add correct card details before continuing!',
            });
            PaymentBus.$emit('reEnableButton');
        },
        pay() {
            this.$refs.paymentRef.submit();
        },
    },
};
</script>

<style>
#stripe-payment-element-errors {
    color: red !important;
}
</style>
